import defaultClient from 'axios';

const wrapErrorManager = (transform, transformError = (e)=>e)=>(data, headers, status)=>{
        const { error  } = data || {};
        const validStatus = defaultClient.defaults.validateStatus(status);
        return error || !validStatus ? transformError(data, headers, status) : transform(data, headers, status);
    };

export { wrapErrorManager };
